import { IonIcon } from "@ionic/react";

interface GridItemProps {
  icon: any;
  title: string;
  value: string | number;
}

const GridItem: React.FC<GridItemProps> = ({ icon, title, value }) => (
  <div className="grid grid-cols-5 gap-4 px-2">
    <div className="text-left col-span-3">
      <IonIcon icon={icon} className="text-primary" /> {title}
    </div>
    <div className="text-left col-span-2">{value}</div>
  </div>
);

export default GridItem;
